import { CUSTOM_PLAN_TRIGGERS } from "../constants/customPlan"

/**
 * Get display value for slider input
 * Shows "250+" or "200+" for custom plan trigger values
 */
export function getDisplayValue(value) {
  const DISPLAY_MAP = {
    [CUSTOM_PLAN_TRIGGERS.SOCIAL_ACCOUNTS]: "+",
    [CUSTOM_PLAN_TRIGGERS.USERS]: "+",
  }
  return DISPLAY_MAP[value] || value
}

/**
 * Check if value is a custom plan trigger
 */
export function isCustomValue(value) {
  return (
    value === CUSTOM_PLAN_TRIGGERS.SOCIAL_ACCOUNTS ||
    value === CUSTOM_PLAN_TRIGGERS.USERS
  )
}
